import { render } from "./App.vue?vue&type=template&id=0bdfa4e9"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0bdfa4e9&lang=scss"

import exportComponent from "/Users/shussain/Development/Web/uk.co.abdulsbaltihouse/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__